import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, Trash2, MessageCircle } from 'lucide-react';

// ✅ Importación exacta según tu archivo
import { obtenerContactos, eliminarContacto } from "../../services/ContactosService";

// Estilos
import '../static/Global.css';
import '../static/Home.css';
import '../static/Aside.css';
import '../static/Flotante.css';

function DashboardContactanos() {
    const [contactos, setContactos] = useState([]);
    const [selectedContacto, setSelectedContacto] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    
    const navigate = useNavigate();

    // ✅ Uso del Servicio Unificado
    useEffect(() => {
        const cargarContactos = async () => {
            try {
                // Usamos la función del servicio en lugar de fetch("/api/contactos")
                const data = await obtenerContactos();
                setContactos(data);
            } catch (error) {
                console.error("Error cargando mensajes:", error);
            } finally {
                setLoading(false);
            }
        };
        cargarContactos();
    }, []);

    const handleVerMensaje = (contacto) => {
        setSelectedContacto(contacto);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedContacto(null);
    };

    const handleEliminar = async (id) => {
      if (window.confirm('¿Estás seguro de que deseas eliminar este mensaje?')) {
        try {
            // Llamada al servicio
            await eliminarContacto(id);

            // Si no hubo error, actualizamos el estado
            setContactos(prev => prev.filter(c => c.id !== id));
            alert("Mensaje eliminado correctamente.");
            
        } catch (error) {
            console.error("Error al eliminar:", error);
            alert("Hubo un error al intentar eliminar el mensaje.");
        }
      }
    };

    return (
        <div className="layout" style={{ display: 'flex', minHeight: '100vh' }}>
            {/* Si tienes un componente Aside, iría aquí */}
            

                <section className="main__content">
                    <div className="table-container">
                        <div className="table-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                            <h2>LISTADO DE MENSAJES</h2>
                        </div>

                        <div className="table-responsive">
                            <table className="novatech-table">
                                <thead>
                                    <tr>
                                        <th>Fecha</th>
                                        <th>Cliente</th>
                                        <th>Teléfono</th>
                                        <th>Descripción</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="5">cargando mensajes...</td>
                            </tr>
                        ) : (
                            contactos.map((contacto) => (
                                <tr key={contacto.id}>
                                    <td data-label="Fecha">
                                        {new Date(contacto.fechaRegistro).toLocaleString('es-PE', {
                                            day: '2-digit',
                                            month: '2-digit',
                                            year: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit'
                                        })}
                                    </td>

                                    <td data-label="Cliente" style={{ fontWeight: 'bold' }}>
                                        {contacto.fullName}
                                    </td>

                                    <td data-label="Teléfono">{contacto.numCel}</td>

                                    <td data-label="Descripción">
                                        <div
                                            className="truncate-text"
                                            style={{
                                                maxWidth: '200px',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis'
                                            }}
                                            title={contacto.description}
                                        >
                                            {contacto.description}
                                        </div>
                                    </td>

                                    <td data-label="Acciones" className="actions-cell">
                                        <button
                                            className="btn-edit"
                                            onClick={() => handleVerMensaje(contacto)}
                                        >
                                            <Eye size={18} />
                                        </button>

                                        <a
                                            href={`https://wa.me/51${contacto.numCel}`}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="btn-edit"
                                            style={{
                                                backgroundColor: '#25D366',
                                                color: 'white',
                                                padding: '8px',
                                                borderRadius: '5px',
                                                display: 'inline-flex'
                                            }}
                                        >
                                            <MessageCircle size={18} />
                                        </a>

                                        <button
                                            className="btn-delete"
                                            onClick={() => handleEliminar(contacto.id)}
                                        >
                                            <Trash2 size={18} />
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                            </table>
                        </div>
                    </div>
                </section>

                {/* MODAL DE DETALLE */}
                {isModalOpen && selectedContacto && (
                    <div className="modal" style={{ display: 'flex', position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
                        <div className="modal-content" style={{ background: 'white', padding: '30px', borderRadius: '8px', width: '90%', maxWidth: '500px' }}>
                            <h2 style={{ marginBottom: '20px', borderBottom: '2px solid #eee', paddingBottom: '10px' }}>DETALLE DEL MENSAJE</h2>
                            
                            <div className="form-group" style={{ marginBottom: '15px' }}>
                                <label style={{ display: 'block', fontWeight: 'bold' }}>Nombre del Cliente:</label>
                                <input type="text" value={selectedContacto.fullName} readOnly style={{ width: '100%', padding: '10px', backgroundColor: '#f9f9f9', border: '1px solid #ddd' }} />
                            </div>

                            <div className="form-group" style={{ marginBottom: '15px' }}>
                                <label style={{ display: 'block', fontWeight: 'bold' }}>Teléfono / Celular:</label>
                                <input type="text" value={selectedContacto.numCel} readOnly style={{ width: '100%', padding: '10px', backgroundColor: '#f9f9f9', border: '1px solid #ddd' }} />
                            </div>

                            <div className="form-group" style={{ marginBottom: '20px' }}>
                                <label style={{ display: 'block', fontWeight: 'bold' }}>Mensaje Completo:</label>
                                <textarea value={selectedContacto.description} rows="6" readOnly style={{ width: '100%', padding: '10px', backgroundColor: '#f9f9f9', border: '1px solid #ddd', resize: 'none' }}></textarea>
                            </div>

                            <div className="actions" style={{ textAlign: 'right' }}>
                                <button className="btn-cancel" onClick={closeModal} style={{ padding: '10px 20px', cursor: 'pointer' }}>
                                    Cerrar Ventana
                                </button>
                            </div>
                        </div>
                    </div>
                )}

        </div>
    );
}

export default DashboardContactanos;